import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@rsos/base-components';
import { fetchMessages } from '@rsos/reduxDataStore/src/features/preconfiguredMessages';
import { selectUserOrgByApp } from '@rsos/sinatra';
import CallChats from '../../CallChats/CallChats';
import OverviewBanners from './OverviewTab/OverviewBanners';

const ChatsTab = () => {
  const dispatch = useDispatch();
  const orgName = useSelector(
    state =>
      selectUserOrgByApp(
        state.sinatra,
        state.sinatra.user.currentRole.application,
      ).name,
  );

  useEffect(() => {
    dispatch(fetchMessages(orgName));
  }, [dispatch, orgName]);

  return (
    <Box gridRowGap="16px" height="100%">
      <OverviewBanners />
      <CallChats />
    </Box>
  );
};

export default ChatsTab;
